import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class XTenantInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const modifiedRequest = request.clone({
      setHeaders: {
        'X-Tenant': !request.url.includes('api/TMS/User/current') ? (localStorage.getItem('tenantId') ?? '') : '',
      },
    });

    return next.handle(modifiedRequest);
  }
}
